export enum Stages {
  LOCAL,
  ALPHA,
  BETA,
  GAMMA,
  PROD,
}

const StageMapping: { [key: string]: Stages } = {
  localhost: Stages.LOCAL,
  "alpha-smartbiz-seller.corp.amazon.com": Stages.ALPHA,
  "beta-smartbiz-seller.corp.amazon.com": Stages.BETA,
  "gamma-smartbiz-seller.corp.amazon.com": Stages.GAMMA,
  "smartbiz.amazon.in": Stages.PROD,
};

const DEFAULT_STAGE = Stages.LOCAL;

export function getCurrentStage(): Stages {
  const currentHostName = window.location.hostname;
  return StageMapping[currentHostName] || DEFAULT_STAGE;
}
